import {createSlice, PayloadAction} from "@reduxjs/toolkit";

const initialState = {
  value:1 //0代表加载完毕,1代表加载中，2、3、4等值留给业务自己使用
};

//一个通用的Loading切面，给各个组件用，但是不要同时使用
export const loadingSlice = createSlice({
  name: "loading",
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.value = action.payload;
    }
  }
});

export const {setLoading} = loadingSlice.actions;

export default loadingSlice.reducer;
